// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderSmallScreen_wrapper__8cl44","logoCTA":"HeaderSmallScreen_logoCTA__T50Gz"};